"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextField = void 0;
const react_1 = __importDefault(require("react"));
const FormField_1 = require("../base/FormField");
const FieldWrapper_1 = require("./FieldWrapper");
class FormTextField extends FormField_1.FormField {
    render() {
        return (react_1.default.createElement(FieldWrapper_1.FormFieldWrapper, Object.assign({}, this.wrapperProps),
            react_1.default.createElement("input", { type: this.props.type || "text", value: this.value, onChange: (e) => this.setValueProxy(e.target.value), className: "form__text-field", onKeyDown: (e) => this.onKeyDownHandler(e), placeholder: this.props.placeholder })));
    }
    setValueProxy(value) {
        if (!!this.props.onlyInt) {
            let intValue = parseInt(value);
            if (Number.isInteger(intValue)) {
                if (intValue < 0) {
                    intValue = intValue * -1;
                }
                value = intValue.toString();
            }
            else {
                value = "";
            }
        }
        this.setValue(value);
    }
    onKeyDownHandler(e) {
        if (e.key === "Enter") {
            if (!!this.props.onEnter) {
                this.props.onEnter();
            }
        }
    }
}
exports.FormTextField = FormTextField;
//# sourceMappingURL=TextField.js.map